module.exports = __webpack_public_path__ + "static/media/bg2.16ad90ab.jpg";